(ns dre.modals.admin.help.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [dre.pages.admin.help.events :as-alias admin-help-page]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :admin :help])

; vvv EVENTS vvv

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [opts]]
  {:db (merge db opts)
   :fx [(when (:preview-help-topic opts)
          [:dispatch [::fetch-help-topic-preview opts]])]}))

(rf/reg-event-fx
 ::fetch-help-topic-preview
 [rf/trim-v]
 (fn-traced
  [_ [opts]]
  {:fx [[::network/request [{:endpoint :admin/help.topic-preview}
                            {:request-content-type :json
                             :response-content-type :json ; TODO: API returns data in transit format
                             :params {:help-topic (get-in opts [:preview-help-topic :confluence-id])}
                             :on-success [::fetch-help-topic-preview-ok]
                             :on-failure [::fetch-help-topic-preview-nok]}]]]}))

(rf/reg-event-fx
 ::fetch-help-topic-preview-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response]}]]
  ; TODO: API returns data in transit format
  {:db (assoc-in db [:preview-help-topic :content] (-> response :body last))
   :fx [[:dispatch [::toggle-preview-loading]]]}))

(rf/reg-event-fx
 ::fetch-help-topic-preview-nok
 [rf/trim-v]
 (fn-traced
  [_ [{::fetch-fx/keys [response]}]]
  ; TODO: notify users
  (js/console.error response)
  {:fx [[:dispatch [::toggle-preview-loading]]]}))

(rf/reg-event-db
 ::toggle-preview-loading
 [(rf/path db-path)]
 (fn-traced
  [db _]
  (update-in db [:preview-help-topic :loading?] not)))

(rf/reg-event-db
 ::on-change
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [k v]]
  (assoc-in db k v)))

(rf/reg-event-fx
 ::add-help-topic
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {::network/request [{:endpoint :admin/help.add-topic}
                      {:body {:confluence-id (get-in db [:add-help-topic :confluence-id])
                              :help-topic "global"}
                       :request-content-type :json
                       :response-content-type :json
                       :on-success [::add-help-topic-ok]
                       :on-failure [::add-help-topic-nok]}]}))

(rf/reg-event-fx
 ::add-help-topic-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ _]
  {:fx [[:dispatch [::modals/clear]]
        [:dispatch [::admin-help-page/init]]]}))

(rf/reg-event-fx
 ::add-help-topic-nok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [{::fetch-fx/keys [response]}]]
  ; TODO: show error to user
  (js/console.error response)
  nil))

(rf/reg-event-fx
 ::delete-help-topic
 [(rf/path db-path)]
 (fn-traced
  [{db :db} _]
  {::network/request [{:endpoint :admin/help.delete-topic}
                      {:body {:help-topic (get-in db [:delete-help-topic :confluence-id])}
                       :request-content-type :json
                       :response-content-type :json
                       :on-success [::delete-help-topic-ok]
                       :on-failure [::delete-help-topic-nok]}]}))

(rf/reg-event-fx
 ::delete-help-topic-ok
 (fn-traced
  [_ _]
  {:fx [[:dispatch [::modals/clear]]
        [:dispatch [::admin-help-page/init]]]}))

(rf/reg-event-fx
 ::delete-help-topic-nok
 [rf/trim-v]
 (fn-traced
  [_ [{::fetch-fx/keys [response]}]]
  ; TODO: show error to user
  (js/console.error response)
  nil))

(rf/reg-event-fx
 ::fetch-confluence-title
 [rf/trim-v]
 (fn-traced
  [_ [confluence-id]]
  {:fx [[::network/request [{:endpoint :admin/help.confluence-title}
                            {:response-content-type :text
                             :params {:confluence-id confluence-id}
                             :on-success [::fetch-confluence-title-ok]
                             :on-failure [::fetch-confluence-title-nok]}]]]}))

(rf/reg-event-db
 ::fetch-confluence-title-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [db [{::fetch-fx/keys [response]}]]
  (assoc-in db [:add-confluence-article :title] (:body response))))

(rf/reg-event-db
 ::fetch-confluence-title-nok
 [(rf/path db-path)]
 (fn-traced
  [db _]
  (assoc-in db [:add-confluence-article :title] "Missing Confluence article")))

(rf/reg-event-fx
 ::add-confluence-article
 [(rf/path db-path)]
 (fn-traced
  [{db :db} _]
  (let [{:keys [help-topic confluence-id]} (:add-confluence-article db)]
    {:fx [[::network/request [{:endpoint :admin/help.add-article}
                              {:request-content-type :json
                               :response-content-type :json
                               :body {:help-topic help-topic
                                      :confluence-id confluence-id}
                               :on-success [::add-confluence-article-ok]
                               :on-failure [::add-confluence-article-nok]}]]]})))

(rf/reg-event-fx
 ::add-confluence-article-ok
 (fn-traced
  [_ _]
  {:fx [[:dispatch [::modals/clear]]
        [:dispatch [::admin-help-page/init]]]}))

(rf/reg-event-fx
 ::add-confluence-article-nok
 [rf/trim-v]
 (fn-traced
  [_ [{::fetch-fx/keys [response]}]]
  ; TODO: notify users
  (js/console.error response)
  nil))

; vvv SUBS vvv

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

(rf/reg-sub
 ::value-of
 :<- [::state]
 (fn [state [_ k]]
   (get-in state k)))

(rf/reg-sub
 ::preview-loading?
 :<- [::state]
 (fn [state _]
   (get-in state [:preview-help-topic :loading?])))
